import TriggerMap from './_TriggerMap';
import TriggerAdder from './_TriggerAdder';
export default {
  name: 'TriggerMapper',
  props: ['feed_id', 'trigger', 'all_triggers', 'integrations'],
  components: {
    TriggerMap: TriggerMap,
    TriggerAdder: TriggerAdder
  },
  data: function data() {
    return {
      show_adder: false
    };
  },
  methods: {
    appendTrigger: function appendTrigger(trigger) {
      this.show_adder = false;
      trigger.feed_id = this.feed_id;
      this.$emit('addTrigger', trigger);
    },
    triggerUpdate: function triggerUpdate() {
      this.$emit('update');
    }
  },
  mounted: function mounted() {
    if (!this.trigger) {
      this.show_adder = true;
    }
  }
};